export default __webpack_public_path__ + "static/media/app-googleplay.1af90472.svg";